export const FETCH_GRAPH_PRACTICE_INCOME_REQUEST = "FETCH_GRAPH_PRACTICE_INCOME_REQUEST";
export const FETCH_GRAPH_PRACTICE_INCOME_SUCCESS = "FETCH_GRAPH_PRACTICE_INCOME_SUCCESS";
export const FETCH_GRAPH_PRACTICE_INCOME_FAILURE = "FETCH_GRAPH_PRACTICE_INCOME_FAILURE";
